module.exports = __webpack_public_path__ + "fe9045dd57f6bfc0629ec2c900d56482.svg";